import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroupDirective } from '@angular/forms';

import { Item } from './models/items.interface';
import { SedsCheckboxOptions } from './enums/seds-checkbox-options.enum';
import { SedsCheckboxPositionsType } from './types/seds-checkbox-positions.type';
import { SedsCheckFormTypeService } from '../../shared/services/seds-check-form-type/seds-check-form-type.service';

@Component({
    selector: 'seds-checkbox',
    templateUrl: './seds-checkbox.component.html',
    styleUrls: ['./seds-checkbox.component.scss'],
    standalone: false
})
export class SedsCheckboxComponent implements OnInit {
  @Input() public controlName!: string;
  @Input() public disabled!: boolean;
  @Input() public items!: Array<Item>;
  @Input() public label?: string;
  @Input() public labelPosition: SedsCheckboxOptions | SedsCheckboxPositionsType = SedsCheckboxOptions.AFTER;
  @Input() public model!: boolean;
  @Input() public required!: boolean;
  @Output() public indeterminateChange = new EventEmitter<Array<Item>>();
  @Output() public modelChange = new EventEmitter<boolean>();

  public selectedColor = 'checkbox-primary';
  public allComplete?: boolean;
  public formControl!: FormControl;

  constructor(
    public checkFormTypeService: SedsCheckFormTypeService,
    private readonly rootFormGroup: FormGroupDirective
  ) {}

  public ngOnInit(): void {
    this.update();
  }

  // ****************************************************************************************
  //
  // Indeterminated implementation following Angular Material documentation avaialable on
  // https://material.angular.io/components/checkbox in Feb/2023.
  //
  // ****************************************************************************************

  public update(): void {
    if (this.checkFormTypeService.isReactiveForm(this.model, this.controlName)) {
      this.updateReactiveForm();
    }
    if (this.model !== undefined) {
      this.updateModel();
    }
    this.indeterminateChange.emit(this.items);
  }

  public updateReactiveForm(): void {
    this.formControl = this.rootFormGroup.control.get(this.controlName) as FormControl;
    if (!(this.items && this.items.length) && this.formControl) {
      this.formControl.setValue(this.allComplete);
      return;
    }

    this.allComplete = this.items.filter(item => item.checked).length === this.items.length;
    this.formControl.setValue(this.items.filter(item => item.checked).length === this.items.length);
  }

  public updateIndeterminated(): boolean {
    if (this.items === undefined) {
      return false;
    }
    return this.items.filter(t => t.checked).length > 0 && !this.allComplete;
  }

  public updateChildren(checked: boolean): void {
    if (this.items !== undefined) {
      this.allComplete = checked;
      this.items.forEach(t => (t.checked = checked));
    }
    this.modelChange.emit(checked);
  }

  public updateModel(): void {
    setTimeout(() => {
      if (this.items) {
        this.allComplete = this.items.every(item => item.checked);
        this.model = this.items.filter(item => item.checked).length === this.items.length;
        this.modelChange.emit(this.model);
      }
    }, 0);
  }
}
